export default __webpack_public_path__ + "static/media/02_photo.8a58a13b.jpg";